import { isDateRangePickerDisplay } from '../../store/states/filterTypes';
import { pixelSizeHelperPortalUi } from '../../utils/pixelSizeHelperPortalUi';

export const FILTER_DYNAMIC_WIDTH_SETTINGS = {
  initialLabelCharacterThreshold: 20,
  maxWidth: pixelSizeHelperPortalUi(560),
  startingWidth: pixelSizeHelperPortalUi(250),
  widthStepSize: pixelSizeHelperPortalUi(30),
  labelCharacterStepSize: 5,
};

export function isDualInputRangeFilterDisplay(
  display: string | undefined
): boolean {
  return (
    display === 'range-number-picker' ||
    (display != null && isDateRangePickerDisplay(display))
  );
}
